import React from 'react';
import { Star } from 'lucide-react';

const DashboardStats = ({ provider, alwaysActive, availableDates }) => {
  return (
    <div className="grid md:grid-cols-4 gap-4 mb-8">
      <div className="bg-white rounded-xl p-5 shadow-sm">
        <p className="text-gray-500 text-sm">Rating</p>
        <div className="flex items-center gap-2">
          <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
          <span className="text-2xl font-bold" data-testid="provider-stat-rating">
            {provider.rating?.toFixed(1) || '0.0'}
          </span>
        </div>
      </div>

      <div className="bg-white rounded-xl p-5 shadow-sm">
        <p className="text-gray-500 text-sm">Reseñas</p>
        <span className="text-2xl font-bold" data-testid="provider-stat-reviews">
          {provider.total_reviews || 0}
        </span>
      </div>

      <div className="bg-white rounded-xl p-5 shadow-sm">
        <p className="text-gray-500 text-sm">Servicios</p>
        <span className="text-2xl font-bold">{provider.services?.length || 0}</span>
      </div>

      <div className="bg-white rounded-xl p-5 shadow-sm">
        <p className="text-gray-500 text-sm">Estado</p>
        <span className={`text-lg font-bold ${alwaysActive ? 'text-green-600' : 'text-orange-500'}`}>
          {alwaysActive ? 'Siempre activo' : `${availableDates.length} dias`}
        </span>
      </div>
    </div>
  );
};

export default DashboardStats;
